import Head from 'next/head'
import React from 'react'

import {
  getStaticPathsFunction,
  getStaticPropsFunction,
  getServerSidePropsFunction,
} from '~/data/page-data'

function OpenRole() {
  return (
    <>
      <div id="grnhse_app" />
      <Head>
        {/* Greenhouse */}
        <script src="https://boards.greenhouse.io/embed/job_board/js?for=impala" />
      </Head>
    </>
  )
}

export default OpenRole

export const getServerSideProps = getServerSidePropsFunction({
  type: '_empty',
})
